var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDasboardLinkArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.793 5.29279C12.9805 5.10532 13.2348 5 13.5 5C13.7652 5 14.0195 5.10532 14.207 5.29279L18.207 9.29279C18.3945 9.48031 18.4998 9.73462 18.4998 9.99979C18.4998 10.265 18.3945 10.5193 18.207 10.7068L14.207 14.7068C14.0184 14.8889 13.7658 14.9897 13.5036 14.9875C13.2414 14.9852 12.9906 14.88 12.8052 14.6946C12.6198 14.5092 12.5146 14.2584 12.5123 13.9962C12.51 13.734 12.6108 13.4814 12.793 13.2928L15.086 10.9998H3.5C3.23478 10.9998 2.98043 10.8944 2.79289 10.7069C2.60536 10.5194 2.5 10.265 2.5 9.99979C2.5 9.73457 2.60536 9.48022 2.79289 9.29268C2.98043 9.10514 3.23478 8.99979 3.5 8.99979H15.086L12.793 6.70679C12.6055 6.51926 12.5002 6.26495 12.5002 5.99979C12.5002 5.73462 12.6055 5.48031 12.793 5.29279Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDasboardLinkArrow);
export default __webpack_public_path__ + "static/media/Dasboard_link_arrow.67e3bc0ab85cc45f752bbe36851eefdd.svg";
export { ForwardRef as ReactComponent };